import { useSelector } from 'hooks/utils';
import { EntryNamesFromUserIds, selectNamesFromUserIds } from 'store/data/entries';

export function useNamesFromUserIds(): EntryNamesFromUserIds {
	const data = useSelector(state => selectNamesFromUserIds(state.data.entries));

	return data;
}
